import React, { memo, useState, useRef, useEffect } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import clsx from 'clsx';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';

import Notification from 'rc-notification';
import { confirmAlert } from "react-confirm-alert";

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

import DatePicker from 'react-date-picker';
// import DatePicker from 'react-date-picker/dist/entry.nostyle';

import ODRAsset from '../order-components/ODRAsset';
import ODROrderBook from '../order-components/ODROrderBook';
import ODRConditionalOrderBook from '../order-components/ODRConditionalOrderBook';
import ODRNotify from '../order-components/ODRNotify';

import ODRStockSuggest from '../order-components/ODRStockSuggest';

import { stock_GetByCode } from '../../redux/getReduxDataStore';
import { getAccTnoDetail, getAccTnoDetailOrder, executeNormalOrder, executeConditionalOrder, getFillPrice } from '../../helpers/apiOrderHelper';

import {  formatNumber, formatNumber_N1, priceToNumber, camelCaseObject } from '../../helpers/utils';
import debounce from 'lodash.debounce';

let notification = null;
Notification.newInstance({
    style: {
        'top': 50, 
        right: 20,
        color: '#000',
    }
}, (n) => notification = n);

const arrPriceStr = ["ATO", "ATC", "MP", "MOK", "MAK", "MTL"];

export default memo(function TabInfo(props) {
    
    const {t} = useTranslation();

    const [selectAccTno, setSelectAccTno] = useState("");
    const [selectCustodyCD, setSelectCustodyCD] = useState("");
    const [selectStockInfo, setSelectStockInfo] = useState({}); 
    
    const [normalOrCondOrder, setNormalOrCondOrder] = useState("N");
    const [orderType, setOrderType] = useState("B");
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const [executingOrder, setExecutingOrder] = useState(false); 

    const userName = useSelector(state => state.gUser.userName);
    const token = useSelector(state => state.gUser.token);
    const tradingAccount = useSelector(state => state.gUser.tradingAccount);

    // Ticket
    // AccTno
    // StockSymbol
    // Price
    // Quantity
    // QuantityNew
    // OrderType
    // OrderId
    // PassTransfer
    // SlipOrderQuantity

    const ref_SuggestCode = useRef(null);

    const ref_AccTno = useRef(null);
    const ref_BuyingPower = useRef(null);
    const ref_Code = useRef(null);
    const ref_Price = useRef(null);
    const ref_Quantity = useRef(null);
    const ref_QuantityLimit = useRef(null);
    const ref_TransPass = useRef(null);
    const ref_MgDensity = useRef(null);
    const ref_Value = useRef(null);
    const ref_ShowConfirmOrder = useRef(null);
    const ref_BuyIn = useRef(null);
    //
    const _getInputPriceVal = () => {
        if(ref_Price.current) {
            return (ref_Price.current.value?.replace(/,/g, '') ?? '').trim();
        }
        return '';
    }
    const _getInputQuantityVal = () => {
        if(ref_Quantity.current) {
            return (ref_Quantity.current.value?.replace(/,/g, '')).trim();
        }
        return '';
    }
    
    const _getAccTnoDetailOrder = () => {
        if(userName && userName !== "") {
            const _price = _getInputPriceVal();
            const _objData = {
                ticket: token,
                accTno: ref_AccTno.current?.value ?? "",
                stockSymbol: selectStockInfo?.code?.toUpperCase() ?? "",
                price: isNaN(_price) ? 0 : Number(_price) * 1000,
                orderType: "N" + orderType,
            }
            
            //
            getAccTnoDetailOrder(_objData).then(function (res) {
                if(res.status === 200) {
                    _showAccTnoDetailOrder(camelCaseObject(res.data));
                }
                else {
                    console.log(res);
                    _showAccTnoDetailOrder(null);
                }
            })
            .catch(function (err) {
                console.log(err);
                _showAccTnoDetailOrder(null);
            });
        }
    }

    const _showAccTnoDetailOrder = (objDetail) => {
        objDetail = objDetail ?? {};
        if(ref_BuyingPower.current) {
            ref_BuyingPower.current.innerText = formatNumber_N1(objDetail.sucMua);
        }
        if(ref_QuantityLimit.current && orderType == 'B') {
            var _price = _getInputPriceVal();
            if(_price == '' || arrPriceStr.includes(_price))  {
                if(isNaN(selectStockInfo?.ceilPrice) || Number(selectStockInfo.ceilPrice) == 0) {
                    ref_QuantityLimit.current.innerText = '';
                }
                else {
                    ref_QuantityLimit.current.innerText = formatNumber(Math.floor(objDetail.sucMua / (Number(selectStockInfo.ceilPrice) * 1000)).toFixed(0));
                }
            }
            else {
                ref_QuantityLimit.current.innerText = formatNumber_N1(objDetail.canBuyQtty);
            }
        }
    }

    const _getAccTnoDetail = () => {
        if(userName && userName !== "") {
            const _objData = {
                ticket: token,
                AccTno: ref_AccTno.current?.value ?? "",
                Symbol: selectStockInfo?.code?.toUpperCase() ?? "",
                OrderType: "N" + orderType,
            }
            //
            getAccTnoDetail(_objData).then(function (res) {
                if(res.status === 200) {
                    _showAccTnoDetail(camelCaseObject(res.data));
                }
                else {
                    console.log(res);
                    _showAccTnoDetail(null);
                }
            })
            .catch(function (err) {
                console.log(err);
                _showAccTnoDetail(null);
            });
        }
    }

    const _showAccTnoDetail = (objDetail) => {
        try {
            //buyingPower: 1810630
            //mgDensity: "Không CV"
            //tradeQTTY: 0
            //sumQtty: 0
            objDetail = objDetail ?? {};
            if(ref_MgDensity.current) {
                ref_MgDensity.current.innerText = objDetail.mgDensity ?? "";
            }
            if([null, undefined, ""].includes(_getInputPriceVal()) && ref_BuyingPower.current) {
                ref_BuyingPower.current.innerText = formatNumber_N1(objDetail.buyingPower);
            }
            if(ref_QuantityLimit.current && orderType == 'S') {
                ref_QuantityLimit.current.innerText = formatNumber_N1(objDetail.tradeQTTY);
            }
        } catch (error) {
        }
    }

    const _handleInputAccTnoChange = () => {
        try {
            const _accTno = ref_AccTno.current?.value ?? "";
            const _custodyCD = tradingAccount?.find((e) => e.AccTno === _accTno)?.CustodyCD ?? "";
            setSelectAccTno(_accTno);
            setSelectCustodyCD(_custodyCD);
            _getAccTnoDetail();
            _getAccTnoDetailOrder();
        } catch (error) {
            console.log(error);
        }
    }

    const _handleOrderTypeChange = (type) => {
        setOrderType(type);
    }

    const _handleInputCodeKeyDown = (event) => {
        if(event && event.keyCode === 13) {
            _handleInputCodeBlur();
        }
    }

    const _handleSuggestCodeChange = (value) => {
        const _code = value?.toUpperCase();
        setSelectStockInfo(stock_GetByCode(_code));
        _handleInputAccTnoChange();
    }

    const _handleInputCodeBlur = () => {
        if(ref_Code.current)
        {
            const _code = ref_Code.current.value?.toUpperCase();
            ref_Code.current.value = _code;
            setSelectStockInfo(stock_GetByCode(_code));
            _handleInputAccTnoChange();
        }
    }

    const _handleInputPriceFocus = () => {
        const _divChoosePriceString = document.getElementById("divChoosePriceString");
        if(_divChoosePriceString) {
            _divChoosePriceString.style.display = 'unset';
        }
    }

    const _handleInputPriceBlur = (event) => {
        try {
            const _divChoosePriceString = document.getElementById("divChoosePriceString");
            if(_divChoosePriceString) {
                _divChoosePriceString.style.display = 'none';
            }
            
            //
            if(ref_Price.current) {
                if(event && event.relatedTarget && event.relatedTarget.classList.contains("ChoosePriceString")) {
                    ref_Price.current.value = event.relatedTarget.getAttribute('data-value');
                }
                const _priceStr = _getInputPriceVal();
                if(isNaN(_priceStr)) {
                    ref_Price.current.value = _priceStr;
                }
                else {
                    ref_Price.current.value = formatNumber(priceToNumber(_priceStr));
                }
            }
            _calcOrderValue();
            _getAccTnoDetailOrder();
        } catch (error) {
            console.log(error);
        }
    }

    
    const _handleInputQuantityBlur = () => {
        try {
            if(ref_Quantity.current) {
                const _quantity = priceToNumber(ref_Quantity.current.value);
                ref_Quantity.current.value = formatNumber(_quantity);
            }
            _calcOrderValue();
        } catch (error) {
            console.log(error);
        }
    }

    const _handleChangeGetPrice =  () => {
        let _qtty = ref_Quantity.current.value;
        let _codeSymbol = selectStockInfo?.code?.toUpperCase() ?? "";
        if(userName && userName !== "" && selectStockInfo?.code && _qtty !== undefined && _qtty !== null && _qtty !== "") {
        const _newValue = {
            OrderQtty : _getInputQuantityVal(),
            BuyIn : ref_BuyIn.current.checked ? "B" : "N",
            symbol : _codeSymbol,
            ticket : token,
        }
        getFillPrice(_newValue).then(function (res) {
            if(res.status === 200) {
                const dataObject = JSON.parse(res?.data?.Msg);
                setSelectStockInfo({
                    ...selectStockInfo,
                    code: _codeSymbol,
                    ceilPrice: dataObject?.CEILINGPRICE,
                    floorPrice: dataObject?.FLOORPRICE,
                    refPrice: dataObject?.BASICPRICE,
                });
            }
        })
        .catch(function (err) {
            console.log(err);
            setSelectStockInfo(stock_GetByCode(_codeSymbol));
        });
        }else {
            setSelectStockInfo(stock_GetByCode(_codeSymbol));
        }
    }

    const handleChange = debounce((event) => {
        _handleChangeGetPrice()
    }, 200);

    const _calcOrderValue = () => {
        try {
            let _price = 0, _quantity = 0;
            const _priceStr = _getInputPriceVal();
            if(isNaN(_priceStr) && arrPriceStr.includes(_priceStr)) {
                if(orderType === "B") {
                    _price = priceToNumber(selectStockInfo?.ceilPrice);
                }
                else if(orderType === "S") {
                    _price = priceToNumber(selectStockInfo?.floorPrice);
                }
            }
            else {
                _price = priceToNumber(_priceStr);
            }

            if(ref_Quantity.current) {
                _quantity = priceToNumber(ref_Quantity.current.value);
            }
            //
            if(ref_Value.current) {
                ref_Value.current.innerText = formatNumber_N1(_price * 1000 * _quantity);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const _handleInputTransPassFocus = () => {
        if(ref_TransPass.current) {
            ref_TransPass.current.removeAttribute('readonly');
        }
    }

    const _handleInputTransPassBlur = () => {
        if(ref_TransPass.current) {
            ref_TransPass.current.setAttribute('readonly', true);
        }
    }

    const _handleButtonOrderClick = () => {
        if(normalOrCondOrder === 'N') {
            _showFormConfirmNormalOrder();
        }
        else if(normalOrCondOrder === 'C') {
            _showFormConfirmConditionalOrder();
        }
    }

    const _showFormConfirmNormalOrder = () => {
        try {
            if(executingOrder) {
                return;
            }
            setExecutingOrder(true);

            // Collect data
            const _objOrder = {
                ticket: token,
                accTno: ref_AccTno.current.value,
                stockSymbol: selectStockInfo?.code,
                price: _getInputPriceVal(),
                quantity: _getInputQuantityVal(),
                orderType: "N" + orderType,
                orderId: 0,
                passTransfer: ref_TransPass.current.value,
                slipOrderQuantity: '',
                BuyIn: ref_BuyIn.current.checked ? "B" : "N", 
            };
            const _showConfirmOrder = ref_ShowConfirmOrder.current.checked;
            if(_showConfirmOrder) {
                confirmAlert({
                    closeOnEscape: false,
                    closeOnClickOutside: false,
                    customUI: ({ onClose }) => {
                        return (
                            <div className="react-confirm-alert">
                                <div className="react-confirm-alert-body">
                                    <h2 className='text-center'>{t('xacNhanLenh')}</h2>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td style={{width: '30%'}}>{t('taiKhoan')}:</td>
                                                <td><b>{_objOrder.accTno}</b></td>
                                            </tr>
                                            <tr>
                                                <td>{t('loaiLenh')}:</td>
                                                <td className={_objOrder.orderType === "NB" ? "clr-up" : _objOrder.orderType === "NS" ? "clr-down" : ""}>
                                                    <b>{(_objOrder.orderType === "NB" ? t('mua') : _objOrder.orderType === "NS" ? t('ban') : "")}</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{t('maCK')}:</td>
                                                <td><b>{_objOrder.stockSymbol}</b></td>
                                            </tr>
                                            <tr>
                                                <td>{t('gia')}:</td>
                                                <td><b>{_objOrder.price}</b></td>
                                            </tr>
                                            <tr>
                                                <td>{t('khoiLuong')}:</td>
                                                <td><b>{_objOrder.quantity}</b></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className='text-center' style={{marginTop: 10}}>
                                        <button type='button' className='btn-sv' onClick={() => {
                                            _executeOrder(_objOrder, onClose);
                                        }}>{t('xacNhan')}</button>
                                        <button type='button' className='btn-ex' onClick={() => {
                                            setExecutingOrder(false);
                                            onClose();
                                        }}>{t('huy')}</button>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                });
            }
            else {
                _executeOrder(_objOrder);
            }
        } catch (error) {
            setExecutingOrder(false);
            console.log(error);
        }
    }

    const _executeOrder = (objData, callback) => {
        executeNormalOrder(objData).then(function (res) {
            if(res.status === 200) {
                const _data = camelCaseObject(res.data);
                if(_data.code === 0) {
                    notification.notice({
                        closable: true,
                        duration: 3,
                        content: t('datLenhThanhCong'),
                        style: {
                            color: 'green',
                        }
                    });
                    _clearFormOrder();
                }
                else {
                    notification.notice({
                        closable: true,
                        duration: 3,
                        content: <span>{_data.msg}</span>,
                        style: {
                            color: 'red',
                        }
                    });
                }
            }
            else {
                console.log(res);
            }
            //
            setExecutingOrder(false);
            if(callback) {
                callback();
            }
        })
        .catch(function (err) {
            setExecutingOrder(false);
            if(callback) {
                callback();
            }
            console.log(err);
            notification.notice({
                closable: true,
                duration: 3,
                content: 'Có lỗi xảy ra',
                style: {
                    color: 'red',
                }
            });
        });
    }

    //
    const _showFormConfirmConditionalOrder = () => {
        try {
            if(executingOrder) {
                return;
            }
            setExecutingOrder(true);

            // Collect data
            const _price = _getInputPriceVal();
            const _objOrder = {
                ticket: token,
                SYMBOL: selectStockInfo?.code,
                AFACCTNO: ref_AccTno.current.value,
                SEACCTNO: '',
                FROMDATE: fromDate && fromDate !== "" ? fromDate.toLocaleDateString('en-GB') : '',
                TODATE: toDate && toDate !== "" ? toDate.toLocaleDateString('en-GB') : '',
                EXECTYPE: "N" + orderType,
                VIA: 'O',
                PRICETYPE: arrPriceStr.includes(_price) ? _price : 'LO',
                ORDERQTTY: _getInputQuantityVal(),
                PRICE: _price,
                TLTXCD: orderType === 'S' ? '8877' : '8876', 
                SELLPROFIT: 'N',
                SELLCUTLOSSES: 'N',
                PRICEPROFIT: '',
                PRICECUTLOSS: '',
                APPROVE: 'N',
                PASSTRANFER: ref_TransPass.current.value,
                OSMARTTYPE: 'FUTURE',
                PRICE_FIXED: ''
            };

            const _showConfirmOrder = ref_ShowConfirmOrder.current.checked;
            if(_showConfirmOrder) {
                confirmAlert({
                    closeOnEscape: false,
                    closeOnClickOutside: false,
                    customUI: ({ onClose }) => {
                        return (
                            <div className="react-confirm-alert">
                                <div className="react-confirm-alert-body">
                                    <h2 className='text-center'>{t('xacNhanLenh')}</h2>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td style={{width: '30%'}}>{t('taiKhoan')}:</td>
                                                <td><b>{_objOrder.AFACCTNO}</b></td>
                                            </tr>
                                            <tr>
                                                <td>{t('loaiLenh')}:</td>
                                                <td className={_objOrder.EXECTYPE === "NB" ? "clr-up" : _objOrder.EXECTYPE === "NS" ? "clr-down" : ""}>
                                                    <b>{(_objOrder.EXECTYPE === "NB" ? t('mua') : _objOrder.EXECTYPE === "NS" ? t('ban') : "")}</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{t('maCK')}:</td>
                                                <td><b>{_objOrder.SYMBOL}</b></td>
                                            </tr>
                                            <tr>
                                                <td>{t('gia')}:</td>
                                                <td><b>{_objOrder.PRICETYPE}</b></td>
                                            </tr>
                                            <tr>
                                                <td>{t('khoiLuong')}:</td>
                                                <td><b>{_objOrder.ORDERQTTY}</b></td>
                                            </tr>
                                            <tr>
                                                <td>{t('hieuLucDenNgay')}:</td>
                                                <td><b>{_objOrder.TODATE}</b></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className='text-center' style={{marginTop: 10}}>
                                        <button type='button' className='btn-sv' onClick={() => {
                                            _executeConditionalOrder(_objOrder, onClose);
                                        }}>{t('xacNhan')}</button>
                                        <button type='button' className='btn-ex' onClick={() => {
                                            setExecutingOrder(false);
                                            onClose();
                                        }}>{t('huy')}</button>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                });
            }
            else {
                _executeConditionalOrder(_objOrder);
            }
        } catch (error) {
            setExecutingOrder(false);
            console.log(error);
        }
    }

    const _executeConditionalOrder = (objData, callback) => {
        executeConditionalOrder(objData).then(function (res) {
            if(res.status === 200) {
                const _data = camelCaseObject(res.data);
                if(_data.code === 0) {
                    notification.notice({
                        closable: true,
                        duration: 3,
                        content: t('datLenhThanhCong'),
                        style: {
                            color: 'green',
                        }
                    });
                    _clearFormOrder();
                }
                else {
                    notification.notice({
                        closable: true,
                        duration: 3,
                        content: <span>{_data.msg}</span>,
                        style: {
                            color: 'red',
                        }
                    });
                }
            }
            else {
                console.log(res);
            }
            //
            setExecutingOrder(false);
            if(callback) {
                callback();
            }
        })
        .catch(function (err) {
            setExecutingOrder(false);
            if(callback) {
                callback();
            }
            console.log(err);
            notification.notice({
                closable: true,
                duration: 3,
                content: 'Có lỗi xảy ra',
                style: {
                    color: 'red',
                }
            });
        });
    }

    const _clearFormOrder = () => {
        try {
            if(ref_SuggestCode.current) {
                ref_SuggestCode.current.clearInput();
            }
            if(ref_Code.current) {
                ref_Code.current.value = "";
            }
            if(ref_Price.current) {
                ref_Price.current.value = "";
            }
            if(ref_Quantity.current) {
                ref_Quantity.current.value = "";
            }
            if(ref_TransPass.current) {
                ref_TransPass.current.value = "";
            }

            setFromDate('');
            setToDate('')

            _calcOrderValue();
            // _handleInputCodeBlur();
            _handleSuggestCodeChange("");
            // _handleInputAccTnoChange(); // Trong _handleInputCodeBlur da goi
        } catch (error) {
            console.log(error);
        }
    }

    //
    useEffect(() => {
        _handleInputAccTnoChange();
    }, []);

    
    useEffect(() => {
        _handleInputAccTnoChange();
        _calcOrderValue();
    }, [orderType]);

    //
    return (
        <div className="boxinfo boxorder">
            <div className="boxinfo__head">
                <div className="headerorder">
                    <div className="headerorder--left">
                        {/* <input type="text" ref={ref_Code} autoFocus onBlur={_handleInputCodeBlur} onKeyDown={_handleInputCodeKeyDown} /> */}
                        <ODRStockSuggest ref={ref_SuggestCode} onSelectedValue={_handleSuggestCodeChange} />
                    </div>
                    <div className="headerorder--right">
                        <div className="headerorder--right__number">
                            <span>{t('tran')}: <span className='cl-bare'>{selectStockInfo?.ceilPrice}</span></span>
                            <span>{t('san')}: <span className='cl-floor'>{selectStockInfo?.floorPrice}</span></span>
                            <span>{t('tc')}: <span className='cl-reference'>{selectStockInfo?.refPrice}</span></span>
                        </div>
                        <div className={clsx("number-exchange", selectStockInfo?.matchPrice_color)}>
                            <span>{selectStockInfo?.matchPrice}</span>
                            <span>{selectStockInfo?.changePrice}/ {selectStockInfo?.pctChangePrice}%</span>
                        </div>
                    </div>
                </div>
                <div className='exchanges'>{selectStockInfo?.marketName}-{selectStockInfo?.symbolName}</div>
                <div className="flex-account">
                    <span className='cl-yellow'>{t('taiKhoan')}</span>
                    <div className="dropdownac">
                        <select ref={ref_AccTno} className='input-default' onChange={_handleInputAccTnoChange}>
                            {tradingAccount && tradingAccount.map((item, index) => {
                                return (
                                    <option key={index} value={item.AccTno}>{item.AccTno}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
                <div className="flex-account">
                    <span className='cl-yellow'>{t('sucMua')}</span>
                    <span>
                        <label ref={ref_BuyingPower}>0</label>
                        <img className='ml-2' src="/static/img/icon/ability.svg" alt="img" />
                    </span>
                </div>
            </div>
            <div className="boxinfo__body h-100">
                <div className="bodyorder">
                    <div className="pd-8">
                        <div className='h-100' style={{paddingBottom: 10}}>
                            <div className='d-flex gap-10 justify-content-center'>
                                <div className={clsx('btn-text btn-normalorcondorder', (normalOrCondOrder === "N" ? "active" : ""))} onClick={() => setNormalOrCondOrder("N")}>{t("lenhThuong")}</div>
                                <div className={clsx('btn-text btn-normalorcondorder', (normalOrCondOrder === "C" ? "active" : ""))} onClick={() => setNormalOrCondOrder("C")}>{t("lenhDieuKien")}</div>
                            </div>
                        </div>
                        <div className='d-flex choose-order-type'>
                            <label className={clsx('flex-1 text-center', (orderType === "B" ? 'active' : ''))} onClick={() => _handleOrderTypeChange("B")}>{t('mua')}</label>
                            <label className={clsx('flex-1 text-center', (orderType === "S" ? 'active' : ''))} onClick={() => _handleOrderTypeChange("S")}>{t('ban')}</label>
                        </div>

                        <div className="ip-price">
                            <div className='ip-name w-100' style={{position: 'relative'}}>
                                <span className='mw-90'>{t("gia")} x1,000</span>
                                <input className='input-default flex-1 text-right' type={"text"} maxLength={15} ref={ref_Price} onFocus={_handleInputPriceFocus} onBlur={_handleInputPriceBlur} />
                                <div id='divChoosePriceString' style={{position: 'absolute', bottom: '100%', right: 0, display: 'none'}}>
                                    <div className='d-flex'>
                                        {arrPriceStr.map((item, index) => {
                                            return (
                                                <button key={index} className='btn-ex pdl-5 pdr-5 ChoosePriceString' style={{width: 'auto'}} data-value={item} tabIndex={-1}>{item}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ip-price w-100">
                            <div className='ip-name flex-1'>
                                <span className='mw-90'>{t("khoiLuong")}</span> 
                                <input className='input-default flex-1 text-right w-100' type={"text"} maxLength={15} ref={ref_Quantity} onBlur={_handleInputQuantityBlur} onChange={handleChange}/>
                            </div>
                            <div className='ip-value ip-mass'>
                                <span>/</span><span ref={ref_QuantityLimit}>0</span>
                            </div>
                        </div>

                        <div className="ip-price w-100">
                            <div className='ip-name flex-1'>
                                <span className='mw-90'>{t('matKhauGD')}</span>
                                <input className='input-default flex-1 text-right' type={"password"} readOnly maxLength={20} ref={ref_TransPass} onFocus={_handleInputTransPassFocus} onBlur={_handleInputTransPassBlur} />
                            </div>
                        </div>

                        {normalOrCondOrder === "C" && (
                            <>
                            <div className="ip-price w-100">
                                <div className='ip-name flex-1'>
                                    <span className='mw-90'>{t('hieuLucDenNgay')}</span>
                                    {/* <DatePicker className='input-default flex-1 text-right w-100' dateFormat="dd/MM/yyyy" selected={toDate} onChange={(date) => setToDate(date)} /> */}
                                    <DatePicker className='input-default flex-1 text-right w-100' format="dd/MM/yyyy" value={toDate} onChange={(date) => setToDate(date)} clearIcon={null} calendarIcon={null} locale={"en-GB"} />
                                </div>
                            </div>
                            </>
                        )}
                        
                        <div className="loan-rate">
                            <span>{t('tyLeChoVay')}</span>
                            <span ref={ref_MgDensity}></span>
                        </div>
                        <div className="value-code">
                            <span>{t("giaTri")}</span>
                            <span ref={ref_Value}></span>
                        </div>
                        <div className="flex-order">
                            <div className="checkbox-order">
                                <input type="checkbox" ref={ref_ShowConfirmOrder} />
                                <span>{t("xacNhanLenh")}</span>
                                <img src="/static/img/icon/icon-info.svg" alt="img" />
                            </div>
                            <div className="checkbox-order">
                                <input type="checkbox" />
                                <span>{t("luuLenh")}</span>
                                <img src="/static/img/icon/icon-info.svg" alt="img" />
                            </div>
                        </div>
                        <div className="flex-order"  style={{paddingTop: "8px"}}>
                            <div className="checkbox-order">
                                <input type="checkbox" ref={ref_BuyIn} onChange={handleChange}/>
                                <span>{t("BUYIN")}</span>
                                <img src="/static/img/icon/icon-info.svg" alt="img" />
                            </div>
                        </div>
                        <div className='d-flex gap-10'>
                            <button type='button' className={clsx('btn-transaction flex-2', (orderType === "S" ? 'btn-sell' : ''))} onClick={_handleButtonOrderClick}>{(orderType === "S" ? t('ban') : t('mua'))} {selectStockInfo?.code}</button>
                            <button type='button' className={clsx('btn-default flex-1')} onClick={_clearFormOrder}>{t("clear")}</button>
                        </div>
                    </div>
                    
                    <Tabs className='bd-asset'>
                        <TabList>
                            <Tab>{t('taiSan')}</Tab>
                            <Tab>{t("soLenh")}</Tab>
                            <Tab>{t("soLenhDieuKien")}</Tab>
                            <Tab>{t('thongBao')}</Tab>
                        </TabList>
                        {/* Tab Tài sản */}
                        <TabPanel>
                            <ODRAsset accTno={selectAccTno} custodyCD={selectCustodyCD} />
                        </TabPanel>

                        {/* Tab Sổ lệnh */}
                        <TabPanel>
                            <ODROrderBook accTno={selectAccTno} />
                        </TabPanel>

                        <TabPanel>
                            <ODRConditionalOrderBook accTno={selectAccTno} />
                        </TabPanel>

                        {/* Tab Thông báo */}
                        <TabPanel>
                            <ODRNotify accTno={selectAccTno} custodyCD={selectCustodyCD} />
                        </TabPanel>

                    </Tabs>
                </div>
            </div>
        </div>
    );
});

// ===== StockGeneral

 
// ===== StockGeneral - End